import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { ChevronDown } from "lucide-react";
import { CLIENTS, ClientEntry } from "@/data/clients";
import { CLIENT_LOGOS } from "@/data/logos";

const NAVY = "#0F0750";

const EntryBody = ({ entry }: { entry: ClientEntry }) => (
  <div className="space-y-3 text-sm sm:text-base leading-relaxed text-slate-600">
    {entry.paragraphs.map((p, i) => (
      <p key={i}>
        {p}
        {entry.link && (
          <>
            {" "}
            <a
              data-testid={`accordion-link-${entry.id}`}
              href={entry.link.href}
              target="_blank"
              rel="noopener noreferrer"
              className="font-medium underline decoration-[#B9C4F2] underline-offset-4 transition-colors hover:text-[#3B5BDB]"
              style={{ color: NAVY }}
            >
              {entry.link.label}
            </a>
          </>
        )}
      </p>
    ))}
  </div>
);

export const ClientsAccordion = () => (
  <AccordionPrimitive.Root
    type="single"
    collapsible
    className="w-full"
    data-testid="clients-accordion"
  >
    {CLIENTS.map((entry) => (
      <AccordionPrimitive.Item
        key={entry.id}
        value={entry.id}
        data-testid={`accordion-item-${entry.id}`}
        className="border-b border-slate-200"
      >
        <AccordionPrimitive.Header className="flex">
          <AccordionPrimitive.Trigger
            data-testid={`accordion-trigger-${entry.id}`}
            className="group flex flex-1 items-center justify-between py-4 text-left font-heading text-sm font-semibold tracking-tight text-slate-800 transition-colors hover:text-[#3B5BDB] md:text-base"
          >
            <span className="flex flex-1 items-center gap-3">
              <img
                src={CLIENT_LOGOS[entry.id]}
                alt={`${entry.title} logo`}
                className="h-6 w-auto max-w-[110px] shrink-0 object-contain"
              />
              {entry.title}
            </span>
            <ChevronDown
              className="h-4 w-4 shrink-0 transition-transform duration-300 group-data-[state=open]:rotate-180"
              style={{ color: NAVY }}
            />
          </AccordionPrimitive.Trigger>
        </AccordionPrimitive.Header>
        <AccordionPrimitive.Content
          data-testid={`accordion-content-${entry.id}`}
          className="overflow-hidden data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
        >
          <div className="pb-5 pt-0">
            <EntryBody entry={entry} />
          </div>
        </AccordionPrimitive.Content>
      </AccordionPrimitive.Item>
    ))}
  </AccordionPrimitive.Root>
);
